var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcorePageHeroLuminousOrbitsBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 820",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arc",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#087CFF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(325 410)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 410,
    ry: 390,
    stroke: "#087CFF",
    strokeOpacity: 0.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 350,
    ry: 330,
    stroke: "#087CFF",
    strokeOpacity: 0.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 280,
    ry: 270,
    stroke: "url(#arc)",
    strokeWidth: 1.4,
    strokeDasharray: "220 50 90 160"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 220,
    ry: 210,
    stroke: "#087CFF",
    strokeOpacity: 0.11,
    strokeDasharray: "3 7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 502,
    r: 3,
    fill: "#FF2775"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663,
    cy: 159,
    r: 3,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 535,
    cy: 713,
    r: 2.5,
    fill: "#087CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcorePageHeroLuminousOrbitsBackground);
export default __webpack_public_path__ + "static/media/fleetcore-page-hero-luminous-orbits-background.c4c5ef32adcbf8316e0ab271a61cbf2d.svg";
export { ForwardRef as ReactComponent };